import { useNavigate } from "react-router-dom";
import { KTRLogo } from "../components/shared/ktr";

export default function NotFound() {
  let navigate = useNavigate();

  return (
    <div className="flex flex-grow mt-20">
      <div className="flex flex-col items-center w-full">
        <div className="h-10 w-10">
          <KTRLogo />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold font-mono text-gray-900">
          404 Not Found
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          We don't know what your looking for, but it's definitely not here...
        </p>
        <div className="mt-5">
          <span
            className="cursor-pointer text-red-600"
            onClick={() => navigate(-1)}
          >
            Go Back
          </span>
        </div>
      </div>
    </div>
  );
}
